import React from "react";

import _ from "underscore";
import AnalyticsTracking from "Utils/AnalyticsTracking";

import { Option } from "Cobalt/Dropdown";
import { Popover } from "Cobalt/Popover";
import Button from "Common/Button";
import SICheckbox from "Common/SICheckbox";
import SIOverlayTrigger from "Common/SIOverlayTrigger";

type Props = {
  filterConfig: any;
  onChangeFilter: (arg0: string, arg1: any) => void;
  options: Array<any>;
  filterKey: string;
  menuTitle: string;
  filterType: string;
  defaultOptions?: Array<any>;
};

class DropdownSubmenuFilter extends React.Component<Props> {
  render() {
    const { filterConfig, options, filterKey, menuTitle, defaultOptions, filterType } = this.props;
    let selectedOptions = null;

    selectedOptions = (filterConfig[filterKey] ? filterConfig[filterKey][filterType] : null) || defaultOptions;

    return (
      <>
        <span className="font-semibold mb-1">{menuTitle}</span>
        {options.map((option, key) => {
          // Disable filter if clicking it would result in a zero plan state
          const checked = _.find(selectedOptions, (val) => _.isEqual(val, option.value)) !== undefined;

          return (
            <Option className="p-4 sm:p-1 flex flex-row justify-between items-center group" key={key}>
              {/** TODO: make functional component, fix propagation issue in here due to tooltip */}
              <div>{this.renderMenuText(option, checked, filterType)}</div>
              <Button
                size="small"
                className="text-caption py-0.5 px-1 ml-2 opacity-0 transition-opacity duration-200 group-hover:opacity-100"
                color="link"
                onClick={() => this.handleClickOnly(option.value, filterType, option.label)}
              >
                ONLY
              </Button>
            </Option>
          );
        })}
      </>
    );
  }

  renderMenuText(option: any, checked: boolean, filterType: string) {
    const checkbox = (
      <SICheckbox
        className="flex-1" // to utilize all "dead space" in the row
        label={option.label}
        checked={checked}
        popover={!!option.tooltip}
        onChange={() => this.handleSelect(option.value, filterType, option.label)}
      />
    );

    if (!option.tooltip) {
      return checkbox;
    }

    // The overlay here was previously non-operational, now it is functional
    const overlayContent = (
      <Popover showBackdrop={false} className="filter-tooltip" id={`${option.label}_filter`}>
        {option.tooltip}
      </Popover>
    );

    return (
      <SIOverlayTrigger
        onClick={() => this.handleSelect(option.value, filterType, option.label)}
        trackType="filter"
        trackId={option.label}
        overlay={overlayContent}
        className="flex-1 text-nowrap"
      >
        {checkbox}
      </SIOverlayTrigger>
    );
  }

  handleSelect(value: any, filterType: string, label: string) {
    const { options, onChangeFilter, filterConfig, filterKey } = this.props;

    const listOptions = options.map((option) => option.value);
    const currentFilter = filterConfig[filterKey];

    // Filters that have options that are hashes with keys of max or min should be converted here into range filters which
    // look like a lot like the include filters except use a list of max/min hashes
    const currentOptions = (currentFilter ? currentFilter[filterType] : null) || listOptions;
    const newFilter = {};

    let actionPerformed = "filter_added";
    // Add or remove the selected option from the new filter
    if (_.find(currentOptions, (val) => _.isEqual(val, value)) !== undefined) {
      newFilter[filterType] = _.reject(currentOptions, (val) => _.isEqual(val, value));

      actionPerformed = "filter_removed";
    } else {
      newFilter[filterType] = currentOptions.concat(value);
    }
    AnalyticsTracking.trackEvent(actionPerformed, {
      location: "dropdown_filters",
      filter_category: this.props.menuTitle,
      changed_filter: label,
    });

    onChangeFilter(filterKey, newFilter);
  }

  handleClickOnly(value: any, filterType: string, label: string) {
    const { onChangeFilter, filterKey } = this.props;
    const newFilter = {};
    const actionPerformed = "only_filter_selected";
    newFilter[filterType] = [].concat(value);
    AnalyticsTracking.trackEvent(actionPerformed, {
      location: "dropdown_filters",
      filter_category: this.props.menuTitle,
      changed_filter: label,
    });

    onChangeFilter(filterKey, newFilter);
  }
}

export default DropdownSubmenuFilter;
